import { useEffect, useMemo, useState } from "react";
import { canvasPixels, drawRotated, loadImage } from "../../masterImages/canvas";
import { rotatedSize } from "../../masterImages/geometry";
import type { MasterImage, Pixels } from "../../masterImages/types";

export interface WorkingImage {
  canvas: HTMLCanvasElement;
  pixels: Pixels;
  scale: number;
}

export const useWorkingImage = (masterImage: MasterImage, rotation: number) => {
  const [preview, setPreview] = useState<HTMLImageElement | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    loadImage(masterImage.preview).then(
      (img) => live && setPreview(img),
      (e: Error) => live && setError(e.message)
    );
    return () => {
      live = false;
    };
  }, [masterImage.preview]);

  const working = useMemo<WorkingImage | null>(() => {
    if (!preview) return null;
    const scale = preview.naturalWidth / masterImage.width;
    const bounds = rotatedSize(masterImage.width, masterImage.height, rotation);
    const canvas = drawRotated(preview, masterImage, rotation, { x: 0, y: 0, ...bounds }, scale);
    return { canvas, pixels: canvasPixels(canvas), scale };
  }, [preview, masterImage.width, masterImage.height, rotation]);

  return { working, error };
};
